import styles from './styles/Items.static.module.scss';
import React, { useState } from 'react';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useHierarchyContext } from '../../hooks/useHierarchyContext';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../constants/searchParamKeys';
import { Ssvg } from '../../../Components/react/Ssvg';
import { SkeletonItemsList } from './Skeleton.items.list';
import { getFilteredSubcollectionObjects } from '../../utils/getFilteredSubcollectionObjects';
const EmptyList = () => (React.createElement("ul", { className: "list:none" },
    React.createElement("li", null, "No results found")));
const Item = ({ item, urlParams }) => {
    const { facetsFromServer } = useAlgoliaDataContext();
    const { objects } = useHierarchyContext();
    const { handle } = useParams();
    const isActive = item.handle === handle;
    const [subsExpanded, setSubsExpanded] = useState(() => {
        return item.handle === objects[handle].parent || isActive;
    });
    const subItems = getFilteredSubcollectionObjects(item.children, facetsFromServer, objects);
    return (React.createElement("li", { className: "pos:r" },
        React.createElement(Link, { to: `/collections/${item.handle}${urlParams}`, className: `d:flex ai:center trs:all:300 hover:text:underline ${styles.itemLink} ${isActive ? `fw:700 ${styles.itemLinkActive}` : ''}` }, item.name),
        subItems.length > 0 &&
            React.createElement("button", { className: `btn:cleared d:flex ai:center jc:center pos:a t:0 r:0 ${styles.buttonExpand}`, onClick: () => { setSubsExpanded(!subsExpanded); } },
                React.createElement(Ssvg, { icon: "#icon--arrow-down", className: `trs:all:300 ${styles.icon} ${!subsExpanded ? styles.iconRotate : ''}` })),
        subItems.length > 0 && subsExpanded &&
            React.createElement(Items, { items: subItems, urlParams: urlParams, className: styles.sublist })));
};
const Items = ({ items, urlParams, className = '' }) => (React.createElement("ul", { className: `list:none ${className}` }, items.map(item => React.createElement(Item, { item: item, urlParams: urlParams, key: item.handle }))));
export const ItemsStatic = () => {
    const { loading, objects } = useHierarchyContext();
    const { medium, handle } = useParams();
    const [searchParams] = useSearchParams();
    if (loading) {
        return React.createElement(SkeletonItemsList, { hierarchyView: true });
    }
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    const currentColObj = objects[handle ?? ''];
    if (currentColObj === undefined) {
        return React.createElement(EmptyList, null);
    }
    const firstColObj = currentColObj.parent !== null
        ? objects[currentColObj.parent] ?? currentColObj
        : currentColObj;
    const searchParamsStr = searchParams.toString();
    let urlParams = '';
    if (medium !== undefined) {
        urlParams += `/${medium}`;
    }
    if (searchParamsStr.length > 0) {
        urlParams += `?${searchParamsStr}`;
    }
    return React.createElement(Items, { items: [firstColObj], urlParams: urlParams });
};
